<div class="py-4 d-flex flex-lg-column" id="kt_footer">
    <div class="container-fluid d-flex flex-column flex-md-row align-items-center justify-content-between">
        <div class="text-dark order-2 order-md-1">
            <span class="me-1">2022 © </span>
            <a href="javascript:void()" target="_blank" class="text-hover-primary">rgrid LLC</a> | 
            <span class="ms-1 fs-9">v{{ settings.release.version }} </span>
        </div>
    </div>
</div>